module.exports = __webpack_public_path__ + "static/media/logoVenue.svg";